export default "__VITE_ASSET__DfY3PiE3__"